
import { Component, Mixins, Watch, Prop, Vue } from 'vue-property-decorator';
import ModelMixin from '@/mixins/ModelMixin';
import ValidateableMixin from '@/mixins/ValidateableMixin';
import { State } from 'vuex-class';
import { UserInfo } from '@/types/user-info';
import { PaymentUser } from '@/types/payment';
import { countriesOptions } from '@/constants/countries';
import { getCurrency } from '@/utils/currency';

@Component({
    components: {},
    mixins: [ModelMixin, ValidateableMixin],
})
export default class UserCountryModal extends Mixins<ValidateableMixin, ModelMixin<boolean>>(
    ValidateableMixin,
    ModelMixin,
) {
    @State('user')
    user!: UserInfo;

    @Prop({ required: true })
    stripePaymentUser!: PaymentUser | null;

    @Prop({ type: Function, required: true })
    updateUserCountry!: (countryDetails: any) => void;

    getCurrency = getCurrency;
    countriesOptions = countriesOptions;
    country: string | undefined = '';
    disableCountry = false;

    async save(e: Event) {
        e.preventDefault();
        if (!this.country) return Vue.toasted.error(`Please select country`);
        this.updateUserCountry({ value: this.country, isoCode: this.getCurrency(this.country ?? '') });
    }

    @Watch('model', { immediate: true })
    onModelChange(newValue: boolean, oldValue: boolean) {
        if (newValue && !oldValue) {
            this.country = this.user.country;
            this.disableCountry = this.stripePaymentUser?.sourceData.currency ? true : false;
        }
    }
}
